module.exports = __webpack_public_path__ + "img/collection-diamondJewelryPlatinum.584e4d0.jpg";